import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AddEmployeeInput, EditEmployeeInput, EmployeeDropdownResult, EmployeeResult, ForgotPasswordInput, GetEmployeesInput, LoginInput, LoginResult, Result, ResultList, SingleResult } from 'app/models';
import { ChangePasswordInput } from 'app/models/employee/change-password-input';
import { ChangePersonalInformationInput } from 'app/models/employee/change-personal-information-input';
import { Utility } from 'app/shared';
import { plainToClassFromExist } from 'class-transformer';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {

  constructor(private httpClient: HttpClient) { }

  public addEmployee(addEmployeeInput: AddEmployeeInput): Promise<Result> {
    return this.httpClient.post(Utility.serviceAddress + 'Employee/AddEmployee', addEmployeeInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public editEmployee(id: number, editEmployeeInput: EditEmployeeInput): Promise<Result> {
    return this.httpClient.put(Utility.serviceAddress + 'Employee/EditEmployee?id=' + id, editEmployeeInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public forgotPassword(forgotPasswordInput: ForgotPasswordInput): Promise<Result> {
    return this.httpClient.post(Utility.serviceAddress + 'Employee/ForgotPassword', forgotPasswordInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public changePersonalInformation(id: number, changePersonalInformationInput: ChangePersonalInformationInput): Promise<Result> {
    return this.httpClient.put(Utility.serviceAddress + 'Employee/ChangePersonalInformation?id=' + id, changePersonalInformationInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public changePassword(id: number, changePasswordInput: ChangePasswordInput): Promise<Result> {
    return this.httpClient.patch(Utility.serviceAddress + 'Employee/ChangePassword?id=' + id, changePasswordInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public deleteEmployee(id: number): Promise<Result> {
    return this.httpClient.delete(Utility.serviceAddress + 'Employee/DeleteEmployee?id=' + id, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public getEmployee(id: number): Promise<SingleResult<EmployeeResult>> {
    return this.httpClient.get(Utility.serviceAddress + 'Employee/GetEmployee?id=' + id, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new SingleResult<EmployeeResult>(EmployeeResult), result))
      .catch(result => plainToClassFromExist(new SingleResult<EmployeeResult>(EmployeeResult), result.error));
  }

  public getEmployees(getEmployeesInput: GetEmployeesInput): Promise<ResultList<EmployeeResult>> {
    return this.httpClient.post(Utility.serviceAddress + 'Employee/GetEmployees', getEmployeesInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new ResultList<EmployeeResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<EmployeeResult>(), result.error));
  }

  public getEmployeeDropdown(): Promise<ResultList<EmployeeDropdownResult>> {
    return this.httpClient.get(Utility.serviceAddress + 'Employee/GetEmployeeDropdown', Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new ResultList<EmployeeDropdownResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<EmployeeDropdownResult>(), result.error));
  }

  public login(loginInput: LoginInput): Promise<SingleResult<String>> {
    return this.httpClient.post(Utility.serviceAddress + 'Employee/Login', loginInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new SingleResult<String>(String), result))
      .catch(result => plainToClassFromExist(new SingleResult<String>(String), result.error));
  }

  public logout(): Promise<Result> {
    return this.httpClient.get(Utility.serviceAddress + 'Employee/Logout', Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public checkPermission(): Promise<SingleResult<LoginResult>> {
    const dashboardToken = localStorage.getItem('dashboardToken');
    if (dashboardToken != null)
      return this.httpClient.get(Utility.serviceAddress + 'Employee/CheckPermission', Utility.options('dashboardToken'))
        .toPromise().then(result => plainToClassFromExist(new SingleResult<LoginResult>(LoginResult), result))
        .catch(result => plainToClassFromExist(new SingleResult<LoginResult>(LoginResult), result.error));
    else {
      const loginResult = new SingleResult<LoginResult>(LoginResult);
      loginResult.success = false;
      loginResult.message = 'UserIsNotLogin';
      return new Promise<SingleResult<LoginResult>>((resolve) => {
        resolve(loginResult);
      });
    }
  }
}
